import sanitizeHtml from "sanitize-html";

const setHtml = (html = "", breakLongUrls = true) => {
  // Handle null/undefined values
  if (html == null) {
    html = "";
  }
  // Break long URLs by inserting word break opportunities
  const urlRegex = /(https?:\/\/[^\s<>]+)/g;
  const processedHtml = breakLongUrls
    ? html.replace(urlRegex, (url) => url.replace(/.{20}/g, "$&<wbr>"))
    : html;

  return {
    dangerouslySetInnerHTML: {
      __html: sanitizeHtml(processedHtml, {
        allowedAttributes: {
          "*": [
            "class",
            "data-legal",
            "disclosure",
            "href",
            "className",
            "target",
            "rel",
          ],
        },
        allowedTags: sanitizeHtml.defaults.allowedTags.concat([
          // Line breaks
          "br",
          "wbr",

          // Emphasis and formatting
          "b",
          "strong",
          "i",
          "em",
          "u",
          "s",

          // Superscript / subscript
          "sup",
          "sub",
        ]),
      }),
    },
  };
};

export default setHtml;
